export default __webpack_public_path__ + "static/media/Watch.8025e571.svg";